import React, { useState, useEffect, useRef } from "react";
import { logo, hamburger, notifications, user } from "../assets";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { changeSideBar } from "../store/actions";
import { LuChevronFirst, LuChevronLast } from "react-icons/lu";
import { RxHamburgerMenu, RxCross1 } from "react-icons/rx";
import { useSelector } from "react-redux";
import ModalClickProfile from "./modals/ModalClickProfile";
import ModalClickNotification from "./modals/ModalClickNotification";
import ModalClickOpenNavbar from "./modals/ModalClickOpenNavbar";
import OverlayRedirect from "./OverlayRedirect";

const NavBar = ({ handleLogout, setLoading, token, interceptFunc = false }) => {
  const navigate = useNavigate();
  const user_ = JSON.parse(localStorage.getItem("user_info"));
  const email = user_.email;
  const profileImage = user_.profile.image.url;
  let package_;
  package_ = user_.package.slug;
  const [openProfile, setOpenProfile] = useState(false);
  const [openNotification, setOpenNotification] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [loc, setLoc] = useState("");
  const isOpen_ = useSelector((state) => state.changeSideBarReducer.isOpen);
  const dispatch = useDispatch();
  const [openNavbar, setOpenNavbar] = useState(false);
  const [notificationsList, setNotificationsList] = useState([]);

  const handleClickProfile = (e) => {
    e.preventDefault();
    setOpenProfile(!openProfile);
  };

  const handleClickNotification = (e) => {
    e.preventDefault();
    setOpenNotification(!openNotification);
  };

  const profileRef = useRef(null);
  const navbarRef = useRef(null);
  const notifRef = useRef(null);

  const handleOutsideClick = (e) => {
    if (
      openProfile &&
      profileRef.current &&
      !e.composedPath().includes(profileRef.current)
    ) {
      setOpenProfile(false);
    } else if (
      openNavbar &&
      navbarRef.current &&
      !e.composedPath().includes(navbarRef.current)
    ) {
      setOpenNavbar(false);
    }

    if (
      openNotification &&
      notifRef.current &&
      !e.composedPath().includes(notifRef.current)
    ) {
      setOpenNotification(false);
    } else if (
      openNavbar &&
      navbarRef.current &&
      !e.composedPath().includes(navbarRef.current)
    ) {
      setOpenNavbar(false);
    }
  };

  const handleClickSideBar = (e) => {
    e.preventDefault();
    dispatch(changeSideBar(!isOpen_));
  };

  useEffect(() => {
    document.body.addEventListener("click", handleOutsideClick);
    return () => {
      document.body.removeEventListener("click", handleOutsideClick);
    };
  }, [openProfile]);
  return (
    <div className="flex flex-row justify-between border border-b-gray-200 py-5 w-full pr-5 pl-8 sticky">
      {showPopup && <OverlayRedirect setOpenOverlay={setShowPopup} loc={loc} />}
      <div className="flex flex-row gap-5 items-center">
        <div
          className="hidden md:flex flex-col justify-start items-center cursor-pointer hover:bg-gray-100 rounded-lg"
          onClick={handleClickSideBar}
        >
          {isOpen_ ? <LuChevronFirst size={30} /> : <LuChevronLast size={30} />}
        </div>
        <div className="relative" ref={navbarRef}>
          <div
            className="flex flex-col md:hidden justify-start items-center cursor-pointer hover:bg-gray-100 rounded-lg"
            onClick={(e) => setOpenNavbar(!openNavbar)}
          >
            {openNavbar ? (
              <RxCross1 size={30} />
            ) : (
              <RxHamburgerMenu size={30} />
            )}
          </div>
        </div>
        <ModalClickOpenNavbar
          navbarRef={navbarRef}
          openNavbar={openNavbar}
          setOpenNavbar={setOpenNavbar}
          package_={package_}
          interceptFunc={interceptFunc}
          setLoc={setLoc}
          setShowPopup={setShowPopup}
        />
        <a href="/" className="cursor-pointer">
          <img src={logo} className="w-[130px]" />
        </a>
      </div>
      <div className="flex flex-row gap-5 justify-end items-center">
        <div className="relative" ref={notifRef}>
          <div
            id="dropdownToggle"
            className="rounded-full p-2 cursor-pointer hover:bg-gray-100 relative"
            onClick={handleClickNotification}
          >
            {notificationsList.length > 0 && (
              <div className="flex h-[10px] w-[10px] bg-green-400 absolute rounded-full right-2"></div>
            )}
            <img src={notifications} className="w-[25px]" />
          </div>
          <ModalClickNotification
            notifications={notificationsList}
            openNotification={openNotification}
          />
        </div>
        <div className="relative" ref={profileRef}>
          <div
            id="dropdownToggle"
            className="rounded-full cursor-pointer hover:shadow-lg"
            onClick={handleClickProfile}
          >
            <img
              src={profileImage ? profileImage : user}
              className="rounded-full w-[40px]"
            />
          </div>
          <ModalClickProfile
            handleClickProfile={handleClickProfile}
            handleLogout={handleLogout}
            user={user}
            email={email}
            setLoading={setLoading}
            token={token}
            openProfile={openProfile}
            interceptFunc={interceptFunc}
            setLoc={setLoc}
            setShowPopup={setShowPopup}
          />
        </div>
      </div>
    </div>
  );
};

export default NavBar;
